import css from "styled-jsx/css";
export const componentStyles = css.global`
  .industry-selection-second-step-wrapper {
    display: flex;
    align-items: center;
    height: calc(100vh - 65px);
    flex-direction: column;
    min-width: 25vw;

    .done-gif-wrapper {
      min-height: 150px;
    }

    .signup-title {
      font-size: 1.969rem;
      font-weight: bold;
      text-align: center;
    }

    .signup-subtitle {
      padding-top: 12px;
      font-size: 1rem;
      font-weight: 100;
      text-align: center;
      line-height: 31px;
    }

    .signup-wrapper {
      padding-top: 32px;
      width: 100%;
    }
  }
`;
